import * as React from "react";
import styled, { css } from "styled-components";
import * as moment from "moment-timezone";
import _ from "lodash";

import { Text } from "src/library/components/Text";
import { useWindowSize } from "src/library/hooks/useWindowSize";

export const WeekDayHeaders: React.ReactFCWithChildren = () => {
  const { width } = useWindowSize();

  const weekDays = React.useMemo(() => {
    if (!width) {
      return [];
    }

    if (width && width > 1200) {
      return [ ...moment.weekdays().slice(1), moment.weekdays()[ 0 ] ];
    } else {
      return [ ...moment.weekdaysShort().slice(1), moment.weekdaysShort()[ 0 ] ];
    }
  }, [ width ]);

  return (
    <WeekHeaders className="week-day-headers">
      {_.map(weekDays, day => (
        <div
          className="day-header"
          key={day}
        >
          <Text color="secondary">
            {day}
          </Text>
        </div>
      ))}
    </WeekHeaders>
  );
};

const WeekHeaders = styled.div`
  ${({ theme }) => css`
    display: flex;
    width: 100%;
    flex: 1 0 14.2857;
    width: 100%;
    padding: ${theme.spacing.padding.sm} ${theme.spacing.padding.md};

    .day-header {
      width: 100%;
      margin-left: 1rem;

      span {
        text-transform: uppercase;
      }
    }
  `}
`;
